import { Navigate } from 'react-router-dom';
import { useAuth } from '../../helper/hooks/useAuth';
import Spinner from '../spinner/Spinner';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <Spinner />;
  return user ? children : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
